import { render, staticRenderFns } from "./WhitelabelFooter.vue?vue&type=template&id=2bd77298"
import script from "./WhitelabelFooter.vue?vue&type=script&lang=js"
export * from "./WhitelabelFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports